'use strict';
(function() {
	angular
			.module('crewProfile')
			.component(
					'otherHubHourComponent',
					{
						templateUrl : 'profile/components/other-hub-hour-component.html',
						controller : function($scope, MessageService,
								ProfileService, EventManagerService,
								PopupManager, crewProfileDTOFactory) {
							var vm = this;
							vm.Type = {
								AUTO : 'A',
								MANUAL : 'M'
							}
							vm.model = {
								manualSearchParams : getDefaultSearchParam(vm.Type.MANUAL),
								autoSearchParams : getDefaultSearchParam(vm.Type.AUTO),
								manuallySetOtherHubHours : [],
								autoImportedOtherHubHours : [],
								manuallySetTotalOtherHubHours : [],
								autoImportedTotalOtherHubHours : [],
								selectedRow : null,
								masterListManual : {
									allSelect : false,
									type : vm.Type.MANUAL
								},
								masterListAuto : {
									allSelect : false,
									type : vm.Type.AUTO
								},
								subtabOtherHub : 1,
								isRowDelete : false
							}

							function getDefaultSearchParam(type) {
								vm.defaultSearchParam = {
									fromDate : '',
									toDate : '',
									crewProfileId : vm.selectedCrewProfileId,
									type : type,
									isImportPrivExist : vm.isImportPrivExist,
									masterList : {
										fromDateAfterToDate : false,
										fromDateFormatInvalid : false,
										toDateFormatInvalid : false
									}
								}
								return vm.defaultSearchParam;
							}

							EventManagerService
									.registerEventListener(
											EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.SEARCH,
											onOtherHubSearch);
							EventManagerService
									.registerEventListener(
											EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.CLEAR,
											clearOtherHubDetails);

							// when search is requested
							function onOtherHubSearch(param) {
								vm.onOtherHubSearch(param);
							}

							function clearOtherHubDetails() {
								vm.model.subtabOtherHub = 1;
								vm.model.manuallySetOtherHubHours = [];
								vm.model.autoImportedOtherHubHours = [];
								vm.model.manuallySetTotalOtherHubHours = [];
								vm.model.autoImportedTotalOtherHubHours = [];
								vm.model.selectedRow = null;
								vm.model.manualSearchParams = getDefaultSearchParam(vm.Type.MANUAL);
								vm.model.autoSearchParams = getDefaultSearchParam(vm.Type.AUTO);
							}

							vm.addNewHubHours = function() {
								vm.model.selectedRow = crewProfileDTOFactory
										.HoursDataDTO();
								vm.model.selectedRow.crewProfileId = vm.selectedCrewProfileId;
								addOrEditOtherHubDetails();
							}

							// delete
							function deleteOtherHubDetails() {
								if (getDeleteDTOList().length == 0) {
									MessageService
											.error('Please select at least one record to Delete');
								} else {
									var details = {
										title : 'Confirmation',
										messages : [ MessageService.MESSAGES.OTHER_HUB_HOURS.DELETE_CONFIRMATION ]
									};
									PopupManager.openModal('CONFIRM_DIALOG',
											details, confirmDeletion);
								}
							}

							// delete confirmation
							function confirmDeletion(pass) {
								if (pass == 'YES') {
									vm.deleteOtherHubHoursData();
								}
							}

							function getDeleteDTOList() {
								var deleteDTOs = [];
								var recordsToDelete = getRecordsToDelete();
								recordsToDelete.forEach(function(record) {
									var data = getDeleteDTO(record);
									if (!!data) {
										deleteDTOs.push(data);
									}
								});
								return deleteDTOs;
							}

							function getDeleteDTO(data) {
								if (!!data) {
									var param = {};
									param.version = data.version;
									param.crewHubFlyingHoursId = data.crewHubFlyingHoursId;
									return param;
								}
								return null;
							}

							function getRecordsToDelete() {
								var recordsToDelete = [];
								if (vm.model.isRowDelete) {
									recordsToDelete.push(angular
											.copy(vm.model.selectedRow));
								} else {
									recordsToDelete = getSelectedRecords(getGridData());
								}
								return recordsToDelete;
							}

							function getGridData() {
								var gridData = [];
								if (vm.model.subtabOtherHub == 1) {
									gridData = vm.model.manuallySetOtherHubHours;
								} else if (vm.model.subtabOtherHub == 2) {
									gridData = vm.model.autoImportedOtherHubHours;
								}
								return gridData;
							}

							function getSelectedRecords(gridData) {
								return _
										.filter(
												gridData,
												function(data) {
													return (!!data.isSelected && data.isSelected === true) ? true
															: false;
												});
							}

							// delete hub data back-end call
							vm.deleteOtherHubHoursData = function() {
								var deleteList = getDeleteDTOList();
								if (deleteList.length > 0) {
									var param = {};
									param.deleteCrewHubHourList = deleteList;

									ProfileService
											.deleteHoursData(
													param,
													function(response) {
														if (response.success) {
															vm
																	.onOtherHubSearch()
															MessageService
																	.success(MessageService.MESSAGES.OTHER_HUB_HOURS.DELETE_SUCCESS);
														}
													}, function(error) {
														MessageService
																.error(error);
													});
								}

							};

							// add or edit other hub hours
							function addOrEditOtherHubDetails() {
								var modelParam = {};
								modelParam.selectedRow = vm.model.selectedRow;
								modelParam.masterList = {
									manualClients : vm.manualClients,
									autoImportClients : vm.autoImportClients
								}
								PopupManager.openModal('OTHER_HUB_EDIT_POPUP',
										modelParam, onModalClose);
							}

							// add or edit confirmation
							function onModalClose(isSuccess) {
								if (isSuccess) {
									vm.onOtherHubSearch();
									MessageService
											.success(MessageService.MESSAGES.OTHER_HUB_HOURS.UPDATE_SUCCESS);
								}
							}

							vm.importHubHours = function() {
								var modelParam = {};
								modelParam.importHour = crewProfileDTOFactory
										.importHoursDataDTO();
								modelParam.importHour.crewProfileId = vm.selectedCrewProfileId;
								modelParam.masterList = {
									autoImportClients : vm.autoImportClients
								}
								PopupManager.openModal(
										'OTHER_HUB_IMPORT_POPUP', modelParam,
										onModalClose);
							}

							vm.clickOnRow = function(selectedRowData, flag) {
								if (!!selectedRowData) {
									vm.model.selectedRow = selectedRowData;
								}
								if (flag == 'DELETE') {
									vm.model.isRowDelete = true;
									deleteOtherHubDetails();
								} else if (flag == 'EDIT') {
									addOrEditOtherHubDetails();
								} else if (flag == 'SELECT_ALL_M') {
									selectDeselectAllGridData(
											vm.model.masterListManual.allSelect,
											vm.model.manuallySetOtherHubHours);
								} else if (flag == 'SELECT_ALL_A') {
									selectDeselectAllGridData(
											vm.model.masterListAuto.allSelect,
											vm.model.autoImportedOtherHubHours);
								} else if (flag == 'SELECT_ROW') {
									setSelectALLCheckBox(selectedRowData);
								}
							};

							vm.deleteAllSelected = function() {
								vm.model.isRowDelete = false;
								deleteOtherHubDetails();
							}

							function setSelectALLCheckBox(selectedRowData) {
								if (selectedRowData.autoImport) {
									if (!selectedRowData.isSelected
											&& vm.model.masterListAuto.allSelect) {
										vm.model.masterListAuto.allSelect = false;
									} else if (isAllRowSelected(vm.model.autoImportedOtherHubHours)) {
										vm.model.masterListAuto.allSelect = true;
									}
								} else {
									if (!selectedRowData.isSelected
											&& vm.model.masterListManual.allSelect) {
										vm.model.masterListManual.allSelect = false;
									} else if (isAllRowSelected(vm.model.manuallySetOtherHubHours)) {
										vm.model.masterListManual.allSelect = true;
									}
								}
							}

							function isAllRowSelected(gridDataList) {
								for ( var i in gridDataList) {
									if (!gridDataList[i].isSelected) {
										return false;
									}
								}
								return true;
							}

							function selectDeselectAllGridData(allSelect,
									OtherHubHours) {
								OtherHubHours.forEach(function(hubHour) {
									hubHour.isSelected = allSelect;
								});
							}
							;

							vm.subtabClick = function(tabID) {
								vm.model.subtabOtherHub = tabID;
							};

							vm.onOtherHubSearch = function(param) {
								if (!!param) {
									if (param === vm.Type.MANUAL) {
										searchManuallySetOtherHubHours();
										searchManuallySetTotalOtherHubHours();
									} else if (param === vm.Type.AUTO) {
										searchAutoImportedOtherHubHours();
										searchAutoImportedTotalOtherHubHours();
									}
								} else {
									searchManuallySetOtherHubHours();
									searchAutoImportedOtherHubHours();
									searchManuallySetTotalOtherHubHours();
									searchAutoImportedTotalOtherHubHours();
								}
							};

							function resetSelectALL() {
								vm.model.masterListManual.allSelect = false;
								vm.model.masterListAuto.allSelect = false;
							}

							// set manually set other hub data
							function searchManuallySetOtherHubHours() {
								var param = getOtherHubHourSearchRequest(false);
								if (!!param) {
									if (vm.model.subtabOtherHub == 1) {
										EventManagerService
												.notifyEventListeners(
														EventManagerService.EVENT.SHOW_HIDE_LOADING,
														true);
									}

									ProfileService
											.searchOtherHubData(
													param,
													function(response) {
														vm.model.manuallySetOtherHubHours = response;
														resetSelectALL();
														if (vm.model.subtabOtherHub == 1) {
															EventManagerService
																	.notifyEventListeners(
																			EventManagerService.EVENT.SHOW_HIDE_LOADING,
																			false);
														}
													},
													function(error) {
														var errorMsg = getError(error);
														if (!!errorMsg) {
															MessageService
																	.error(errorMsg);
														} else {
															MessageService
																	.error('Other Hub Data Retrieval Error');
														}

														if (vm.model.subtabOtherHub == 1) {
															EventManagerService
																	.notifyEventListeners(
																			EventManagerService.EVENT.SHOW_HIDE_LOADING,
																			false);
														}
													});
								}
							}
							;

							// search total summary of manually set other hub
							// hours
							function searchManuallySetTotalOtherHubHours() {
								var param = getOtherHubHourSearchRequest(false);
								if (!!param) {
									ProfileService
											.searchTotalOtherHubData(
													param,
													function(response) {
														vm.model.manuallySetTotalOtherHubHours = response;
														resetSelectALL();
													},
													function(error) {
														var errorMsg = getError(error);
														if (!!errorMsg) {
															MessageService
																	.error(errorMsg);
														} else {
															MessageService
																	.error('Total Other Hub Data Retrieval Error');
														}

													});
								}
							}
							;

							// search auto import other hub data
							function searchAutoImportedOtherHubHours() {
								var param = getOtherHubHourSearchRequest(true);
								if (!!param) {
									if (vm.model.subtabOtherHub == 2) {
										EventManagerService
												.notifyEventListeners(
														EventManagerService.EVENT.SHOW_HIDE_LOADING,
														true);
									}
									ProfileService
											.searchOtherHubData(
													param,
													function(response) {
														vm.model.autoImportedOtherHubHours = response;
														resetSelectALL();
														if (vm.model.subtabOtherHub == 2) {
															EventManagerService
																	.notifyEventListeners(
																			EventManagerService.EVENT.SHOW_HIDE_LOADING,
																			false);
														}
													},
													function(error) {
														var errorMsg = getError(error);
														if (!!errorMsg) {
															MessageService
																	.error(errorMsg);
														} else {
															MessageService
																	.error('Auto Imported Hub data retrieval error');
														}
														if (vm.model.subtabOtherHub == 2) {
															EventManagerService
																	.notifyEventListeners(
																			EventManagerService.EVENT.SHOW_HIDE_LOADING,
																			false);
														}
													});
								}
							}
							;

							// search total summary in auto import
							function searchAutoImportedTotalOtherHubHours() {
								var param = getOtherHubHourSearchRequest(true);
								if (!!param) {
									ProfileService
											.searchTotalOtherHubData(
													param,
													function(response) {
														vm.model.autoImportedTotalOtherHubHours = response;
														resetSelectALL();
													},
													function(error) {
														var errorMsg = getError(error);
														if (!!errorMsg) {
															MessageService
																	.error(errorMsg);
														} else {
															MessageService
																	.error('Total Auto Imported Hub data retrieval error');
														}
													});
								}
							}
							;

							function getError(error) {
								if (!!error) {
									if (!!error.msg
											&& error.msg.length > 0) {
										return error.msg[0];
									} else if(!!error.msg && error.msg.length !== 0) {
										return error.msg;
									}
									return error;
								}
								return null;
							}

							// get other hub search data search request
							function getOtherHubHourSearchRequest(isAutoImport) {
								var searchParam = isAutoImport ? vm.model.autoSearchParams
										: vm.model.manualSearchParams;
								if (!!searchParam && !!vm.selectedCrewProfileId) {
									var param = {};
									param.fromDate = searchParam.fromDate;
									param.toDate = searchParam.toDate;
									param.crewProfileId = vm.selectedCrewProfileId;
									param.isAutoImport = isAutoImport;
									return param;
								}
								return null
							}
							;
						},
						bindings : {
							selectedCrewProfileId : '=',
							manualClients : '=',
							autoImportClients : '=',
							isImportPrivExist : '='
						}
					});
})();